var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickSm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33975",
    "data-name": "Group 33975",
    transform: "translate(-314.67 -106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checkbox",
    transform: "translate(314.67 106)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy_2",
    "data-name": "Ellipse 1 copy 2",
    cx: 5,
    cy: 5,
    r: 5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy_2",
    "data-name": "Shape 1 copy 2",
    d: "M324.109,115.065a.325.325,0,0,0-.479,0l-4.061,4.308-1.561-1.656a.325.325,0,0,0-.479,0,.375.375,0,0,0,0,.509l1.8,1.91a.326.326,0,0,0,.479,0l4.3-4.563A.375.375,0,0,0,324.109,115.065Z",
    transform: "translate(-315.909 -112.606)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSm);
export default __webpack_public_path__ + "static/media/tick-sm.275101e50cb929860082c684ea5e999b.svg";
export { ForwardRef as ReactComponent };